var getHeight = function(obj) {
		var objStyles = window.getComputedStyle(obj),
			objDisplay = objStyles.display,
			objPosition = objStyles.position,
			objVisibility = objStyles.visibility,
			wantedHeight;

		obj.style.position = 'absolute';
		obj.style.visibility = 'hidden';
		obj.style.display = 'block';

		wantedHeight = obj.offsetHeight;

		obj.style.position = objPosition;
		obj.style.visibility = objVisibility;
		obj.style.display = objDisplay;
		
		return wantedHeight;
	};

module.exports = getHeight;